module.exports = __webpack_public_path__ + "static/media/instagram.f2727d65.svg";